<p-breadcrumb
  [model]="[{ label: 'Produtos', routerLink: ['/products'] }]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<p-toolbar class="mb-5 mt-5">
  <div class="w-full flex justify-between items-center">
    <div>
      <h5 class="font-bold">Produtos</h5>
      <p>Gerencie o catálogo de produtos</p>
    </div>
    <p-button label="Novo Produto" routerLink="/products/create" rounded />
  </div>
</p-toolbar>

<p-table
  #table
  [value]="products()"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [paginator]="true"
  [paginatorStyleClass]="'flex justify-end!'"
  [rows]="pageSize()"
  [rowsPerPageOptions]="[10, 20, 50]"
  [totalRecords]="totalRecords()"
  [loading]="loading()"
  [first]="paginationService.pageToFirst(pageNumber(), pageSize())"
  paginatorLocale="pt-BR"
>
  <ng-template #caption>
    <div class="flex gap-5 items-center">
      <p>Filtrar por:</p>
      <div class="w-100">
        <input
          pInputText
          type="text"
          id="nameFilter"
          class="block"
          [(ngModel)]="nameFilter"
          (ngModelChange)="onFilterChange()"
          placeholder="Nome"
          fluid
        />
      </div>
      <div class="w-100">
        <input
          pInputText
          type="text"
          id="skuFilter"
          class="block"
          [(ngModel)]="skuFilter"
          (ngModelChange)="onFilterChange()"
          placeholder=" SKU"
          fluid
        />
      </div>
    </div>
  </ng-template>

  <ng-template #header>
    <tr>
      <th>Imagem</th>
      <th>Nome</th>
      <th>SKU</th>
      <th>Versão do modelo</th>
      <th>Status</th>
      <th class="flex justify-center">Ações</th>
    </tr>
  </ng-template>

  <ng-template #body let-item>
    <tr>
      <td style="min-width: 5rem">
        @if (item.mainImageUrl) {
          <img [src]="item.mainImageUrl" alt="productImage" class="w-10" />
        }
      </td>
      <td>{{ item.name }}</td>
      <td>{{ item.sku }}</td>
      <td>{{ item.modelVersionName }}</td>
      <td>
        <app-tag-status
          [status]="item.status"
          [text]="getStatusDescription(item.status)"
          class="px-3!"
        />
      </td>
      <td>
        <p-button
          icon="ph-duotone ph-pencil"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/products/update/' + item.id"
        />
        <p-button
          icon="ph-duotone ph-eye"
          class="mr-2"
          [rounded]="true"
          [outlined]="true"
          [routerLink]="'/products/details/' + item.id"
        />
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="6">
        <p class="text-center">Nenhum registro encontrado!</p>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-toast />
